import * as React from 'react';

// Adds the lp-visible class once the element scrolls into view.
// Usage: <Reveal delay={1}> ... </Reveal>  (delay: 0-3, maps to lp-reveal-dN)
export default function Reveal({ children, delay = 0, style, className = '' }) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      el.classList.add('lp-visible');
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('lp-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const delayClass = delay > 0 ? ` lp-reveal-d${Math.min(delay, 3)}` : '';

  return (
    <div ref={ref} className={`lp-reveal${delayClass} ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}
